import { render, staticRenderFns } from "./ProductIntegrationDiagnosticCmp.vue?vue&type=template&id=ad23c6b4&scoped=true&"
import script from "./ProductIntegrationDiagnosticCmp.vue?vue&type=script&lang=js&"
export * from "./ProductIntegrationDiagnosticCmp.vue?vue&type=script&lang=js&"
import style0 from "./ProductIntegrationDiagnosticCmp.vue?vue&type=style&index=0&id=ad23c6b4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad23c6b4",
  null
  
)

export default component.exports